import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
import { Helmet } from "react-helmet";

import "../ImportExport/ServicePages.css";
const AnnualFiling = () => {
   const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }

  return (
    <div className="service-page">

      {/* SEO */}
      <Helmet>
        <title>Annual Filing of Company | ROC Filing Services India</title>
        <meta
          name="description"
          content="Get your company annual filing done on time. Expert ROC filing services including AOC-4, MGT-7, financial statements, and compliance support."
        />
        <meta
          name="keywords"
          content="annual filing company, ROC filing, AOC-4, MGT-7, company compliance India, annual return filing"
        />
      </Helmet>

      {/* HERO */}
      <section className="service-hero">
        <h1>Annual Filing of Company</h1>
        <p>Stay compliant with ROC regulations and avoid penalties</p>
        <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          Annual filing is a mandatory compliance requirement for every registered company. 
          It ensures that financial and operational details are properly reported to the 
          Registrar of Companies (ROC).
        </p>
        <p>
          Timely filing helps avoid penalties, maintain legal status, and build trust with stakeholders.
        </p>
      </section>

      {/* INCLUDED SERVICES */}
      <section className="service-section">
        <h2>What is Included in Annual Filing?</h2>
        <ul>
          <li>Preparation and filing of Annual Returns</li>
          <li>Filing of Financial Statements</li>
          <li>Drafting of Board Reports</li>
          <li>Director’s Report Preparation</li>
          <li>Compliance with ROC requirements</li>
          <li>Maintenance of statutory records</li>
        </ul>
      </section>

      {/* FORMS */}
      <section className="service-section">
        <h2>Key ROC Forms Covered</h2>
        <div className="card">AOC-4 – Financial Statements Filing</div>
        <div className="card">MGT-7 / MGT-7A – Annual Return Filing</div>
        <div className="card">ADT-1 – Auditor Appointment (if applicable)</div>
      </section>

      {/* WHO NEEDS */}
      <section className="service-section">
        <h2>Who Needs Annual Filing?</h2>
        <ul>
          <li>Private Limited Companies</li>
          <li>One Person Companies (OPC)</li>
          <li>Limited Companies</li>
          <li>Section 8 Companies</li>
        </ul>
        <p>
          Even if your company has no business activity, annual filing is still mandatory.
        </p>
      </section>

      {/* DUE DATES */}
      <section className="service-section">
        <h2>Due Dates to Remember</h2>
        <div className="card">Financial Statements: Within 30 days of AGM</div>
        <div className="card">Annual Return: Within 60 days of AGM</div>
        <p>
          Missing deadlines can result in heavy penalties and legal complications.
        </p>
      </section>

      {/* IMPORTANCE */}
      <section className="service-section">
        <h2>Why is Annual Filing Important?</h2>
        <ul>
          <li>✔ Avoid penalties and late fees</li>
          <li>✔ Maintain legal status of the company</li>
          <li>✔ Build credibility with investors and banks</li>
          <li>✔ Ensure transparency and proper record-keeping</li>
        </ul>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>✔ Expert handling of ROC compliance</li>
          <li>✔ Timely reminders and filings</li>
          <li>✔ Accurate documentation</li>
          <li>✔ End-to-end support</li>
          <li>✔ Affordable pricing</li>
        </ul>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Stay Compliant & Penalty-Free</h2>
        <p>Let our experts handle your annual filing efficiently.</p>
        <button>Get Started Today</button>
      </section> */}

               <div className="cta" ref={contactRef}>
              <h2>Stay Compliant & Penalty-Free</h2>
              <p>Let our experts handle your annual filing efficiently.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>


    </div>
  );
};

export default AnnualFiling;